export default __webpack_public_path__ + "static/media/affiche2007.9144746a.png";